require('iframe-resizer');

var logged_in = window.logged_in ? window.logged_in : false;
let jobs = window.jobs ? window.jobs : {};
let jobID = window.jobID ? window.jobID : null;
let jobIDs = window.jobIDs ? window.jobIDs : [];
let refTpl = window.refTpl ? window.refTpl : null;
let searchXHR, loadXHR, bmXHR, mapXHR;

$(function() {
    //Record Outbound Link
    $(".record-obl").on("click", function() {
        recordOutboundLink($(this).data("pagecode") ?$(this).data("pagecode") : 'splitnav', $(this).data("jb_id"), dv($(this).data("price")));
    });

    /*$("#ad").swipe({
        swipe: function(event, direction, distance, duration, fingerCount, fingerData) {
            if (direction == "left") {
                $("#navigator .prev").trigger("click");
            }
            if (direction == "right") {
                $("#navigator .next").trigger("click");
            }
        }
    });*/

    if (window.history) {
        $(window).on("popstate", function(e) {
            $("#result-wrapper").addClass("old-search");
            if (e.originalEvent.state) {
                $("#result-wrapper").data("token", e.originalEvent.state.token);
            }
            search(1);
        });
    }

    $(window).on("load resize scroll", function() {
        window.debounce(setResultHeight(), 1000);
    })




    $("#modalNeedLogin .login .submit").on("click", function() {
        $.ajax({
            "type": "POST",
            "url": "/authenticate",
            "dataType": "json",
            "headers": { "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content") },
            "data": {
                username: $("#modalNeedLogin .login .username").val(),
                password: $("#modalNeedLogin .login .password").val()
            },
        }).done(function() {
            location.reload();
        }).fail(function() {
            $("#modalNeedLogin .msg").append(`
                <div class="alert alert-danger alert-dismissible fade show" role="alert">
                    Login fehlgeschlagen!
                    <button type="button" class="close" data-dismiss="alert" aria-label="Verwerfen">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
            `).slideDown("slow");
        });
    });




    // -------------- //
    // --- SEARCH --- //
    // -------------- //

    $("#qs-combined").on('keyup', function(e) {
        if (e.key === 'Enter') {
            search();
        }
    });
    
    $(".fknd-search").on('click', '.btn', function(e) {
        e.preventDefault();
        search();
    });




    // -------------- //
    // --- FILTER --- //
    // -------------- //

    $("#filters .modules").on("click", ".module", function() {
        if ($(this).hasClass("active")) {
            $("#filters .current").collapse("hide");
            $("#filters .modules .module").removeClass("active")
        } else {
            $("#filters .modules .module").removeClass("active")
            $(this).addClass("active");
            let sections = $(this).find(".sections").html()
            $("#filters .current .sections").html(sections);
            $("#filters .current").collapse("show");
        }
    });
    
    $("#filters .current").on("click", ".tipp", function() {
        let tipp = $(this);
        let isactive = tipp.hasClass("active")
        let section = tipp.parents(".section");
        let type = section.data("type");

        if (type == 'pid') {
            $('#qs-combined').val('');
        }

        let orig = $("#filters .modules .module.active");

        $("#filters").find(".section[data-type='" + type + "'] .tipp").removeClass("active");

        if (!isactive) {
            let section_o = orig.find(".section").get(section.index());
            let tipp_o = $(section_o).find(".tipp").get(tipp.index());
            $([tipp_o, this]).addClass("active");
        }

        search(1);
    });

    $("#filters .tippcount").on("click", function() {
        if ($("#filters .modules .module .section[data-type='pid'] .tipp:not(.all).active").length) {
            $('#qs-combined').val('');
        }
        $("#filters").find(".tipp").removeClass("active");
        $(this).hide();
        search(1);
    });




    // --------------- //
    // --- RESULTS --- //
    // --------------- //

    $("#result, #result-wrapper").on("click", ".fknd-job", function(e) {
        e.preventDefault();
        if (!$("#content").hasClass("show")) {
            $(".toggle-nav-show").toggleClass("show");
        }
        $("#filters .current").collapse("hide");
        $("#filters .modules .module").removeClass("active")
        if (!$(this).hasClass(".active")) {
            selectJob(this);
        }
    });

    $("#result-more").on("click", function() {
        load();
    });




    // ----------------- //
    // --- NAVIGATOR --- //
    // ----------------- //

    $("#navigator").on("click", ".prev:not(.disabled)", function() {
        let prev = $("#result-list .fknd-job.active").prev(".fknd-job");
        if (prev.length) {
            selectJob(prev);
        }
    });

    $("#navigator").on("click", ".next:not(.disabled)", function() {
        let next = $("#result .fknd-job.active").length || !$("#result-list .fknd-job.active").length ? $("#result-list .fknd-job").first() : $("#result-list .fknd-job.active").next(".fknd-job");
        if (next.length) {
            selectJob(next);
        }
    });

    $("#navigator").on("click", ".more:not(.disabled)", function() {
        load();
    });

    $("#navigator").on("click", ".list", function() {
        if (!$("#sidebar").hasClass("show")) {
            $(".toggle-nav-show").toggleClass("show");
        }
        scrollToSelected();
    });




    // ---------------- //
    // --- PAGELOAD --- //
    // ---------------- //

    $("#ad img.preview")
        .attr("src", $("#ad .preview").data("load-preview"))
        .removeAttr("data-load-preview");


    if (jobIDs.length) {
        tracking.send({cid: jobIDs.join(","), type: 'list'});
    }

    if (jobID != null) {
        selectJob($("#result .fknd-job").first());
    }

    if (window.history) {
        window.history.replaceState({ token: $("#result-wrapper").data("token"), jobID: jobID }, '');
    }

    if (!$("#result-wrapper .fknd-job.active").length && $("#result-list .fknd-job").length) {
        selectJob($("#result-list .fknd-job").first());
    }

    if ($("#result-list").hasClass("deferred")) {
        search();
    }

});

/**
 * Teilenbanner des ausgewählten Jobs einklappen
 */
function collapseShare() {
    if (!$("#toolbar").find(".share-toggle:focus").length &&
        !$("#toolbar").find(".share:hover").length &&
        !$("#toolbar .share").find(":focus").length) {
        $("#toolbar .share").collapse("hide");
    };
}


/**
 * Zum ausgewählten Job scrollen
 */
function scrollToSelected() {
    setTimeout(function() {
        let pos = 
            $("#result-list .fknd-job.active").offset().top +
            $("#result-list .fknd-job.active").outerHeight(true) / 2 -
            $(window).innerHeight() / 2;

        $(window).scrollTop(pos)
    }, 10);
}

/**
 * Zeigt die JobDetails an
 * @param {string} html Job
 */
function setJobDetails(html) {

    $("#details").replaceWith(html);
    window.checkSources("#details");
    window.deferredSrc("#details");

    initToolbar();

    $("#ad .preview").on("error", function() {
        $("#ad").empty().removeClass("fknd-job-layout-img");
    }).on("load", function() {
        $("#ad .previewinfo").stop(true, true).show();
    });

    $("#ad iframe").on('load', function () {
        iFrameResize({ heightCalculationMethod: 'lowestElement' }, '#ad iframe');
    });

    if (bmXHR && bmXHR.readyState != 4) {
        bmXHR.abort();
    }
    bmXHR = $.ajax({
        "type": "POST",
        "url": "/ajax/isbookmark",
        "dataType": "json",
        "headers": { "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content") },
        "data": { id: $("#meta").data("id") }, 
    }).done(function(response, textStatus) {
        $("#toolbar .bookmarkjob").toggleClass("checked", response).toggleClass("unchecked", !response);
    });

    if ($(window).scrollTop() > $("#content").position().top) {
        $(window).scrollTop($("#content").position().top);
    }

    if (mapXHR && mapXHR.readyState != 4) {
        mapXHR.abort();
    }
    mapXHR = $.ajax({
        "type": "GET",
        "url": $("#map").data("url"),
        "headers": { "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content") }, 
    }).done(function(response, textStatus) {
        $("#map").html(response).show();
    });

    tracking.send({cid: $("#meta").data("id"), type: 'view'});
    if (typeof ga !== 'undefined') {
        ga('send', 'pageview', $("#meta").data("url"));
    }

    setResultHeight();
}

/**
 * Einen Job aus der Ergebnisliste auswählen
 * @param {Element} job auszuwählendes DOM-Element
 */
function selectJob(job) {
    if (!$(job).length) {
        $("#details").empty();
        return;
    }

    setJobDetails(jobs[$(job).data("id")]);

    let isFirst = $(job).get(0) == $("#result-list .fknd-job").first().get(0) || $(job).get(0) == $("#result .fknd-job").first().get(0);
    let isLast = $(job).get(0) == $("#result-list .fknd-job").last().get(0);
    $("#navigator .prev").prop("disabled", isFirst).toggleClass("disabled", isFirst);
    $("#navigator .next").prop("disabled", isLast).toggleClass("disabled", isLast);

    if (isLast && !$("#result-list").hasClass("all-loaded")) {
        $("#navigator .next").addClass("d-none");
        $("#navigator .more").removeClass("d-none");
    } else {
        $("#navigator .next").removeClass("d-none");
        $("#navigator .more").addClass("d-none");
    }

    //Aktiven Job setzen
    $("#result .fknd-job, #result-wrapper .fknd-job").removeClass("active");
    $(job).addClass("active");
}

/**
 * Eine neue Suche vorbereiten und ausführen
 * @param {Boolean} tippsearch Suche wurde vom Tippmodul ausgelöst
 */
function search(tippsearch = false) {
    //Laufende Suche abbrechen
    if (loadXHR && loadXHR.readyState != 4) {
        loadXHR.abort();
    }
    if (searchXHR && searchXHR.readyState != 4) {
        searchXHR.abort();
    } else {
        $("#result-wrapper > .spinner").fadeIn();
    }

    $("#result-list").removeClass("all-loaded");
    $('#qs-combined').trigger('blur');
    if ($("#content").hasClass("show") && !$("#result-list").hasClass("deferred")) {
        $(".toggle-nav-show").toggleClass("show");
    }

    //Daten aufbereiten
    let data = {};
    if ($("#result-wrapper").hasClass("old-search")) {
        data.oldsearch = "1";
        data.token = $("#result-wrapper").data("token");
        if (window.history && window.history.state) {
            data.job_id = window.history.jobID;
            data.ref_tpl = window.history.state.refTpl;
        }
    }
    if ($("#result-list").hasClass("deferred")) {
        data.token = $("#result-wrapper").data("token");
        data.job_id = jobID;
        data.ref_tpl = refTpl;
    } else {
        data.qs_combined = $("#qs-combined").val();
        data.phrase = $("#qs-phrase").val();
        data.location = $("#qs-location").val();
        data.inputsearch = tippsearch ? "0" : "1";
        data.ref_tpl = refTpl;
        if (tippsearch) {
            $("#filters .modules .module .section").each(function() {
                let type = $(this).data("type");
                data[type] = "";
                $(this).find(".tipp.active").each(function() {
                    if (data[type] !== undefined && data[type].length) {
                        data[type] += "," + $(this).data("query");
                    } else {
                        data[type] = $(this).data("query");
                    }
                });
            });
        }
    }
    

    //AJAX
    searchXHR = $.ajax({
        "type": "POST",
        "url": "/suchergebnis",
        "dataType": "json",
        "headers": { "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content") },
        "data": data,
    }).done(function(response) {
        $("#qs-combined").val(response.combined);
        $("#qs-phrase").val(response.phrase);
        $("#qs-location").val(response.location);

        let deferred = $("#result-list").hasClass("deferred");

        $("#result-info").replaceWith(response.info);
        window.checkSources("#result-info");
        window.deferredSrc("#result-info");
        let wrapper = $(response.list);
        let list = $(wrapper).find("#result-list");
        $("#result-list").replaceWith(list);
        window.checkSources("#result-list");
        window.deferredSrc("#result-list");

        jobs = response.details;

        tracking.send({cid: response.ids.join(","), type: 'list'});
        //ga('send', 'pageview', response.url);

        if (!deferred) {
            $("#result").remove();
            if (window.history && history.pushState && !$("#result-wrapper").hasClass("old-search")) {
                window.history.pushState({
                    path: response.url,
                    token: response.token,
                    jobID: response.job_id ? response.job_id : null,
                    refTpl: response.ref_tpl ? response.ref_tpl : null
                }, '', response.url);
            }
            $(document).attr("title", response.title);
            if (response.modules) {
                renderModules(response.modules);
            }
        }

        if (!response.job_id) {
            selectJob($("#result-list .fknd-job").first());
        }

        let tippsactive = $("#filters .modules .tipp.active:not(.all)").length;
        $("#filters .tippcount").text(tippsactive);
        if (tippsactive) {
            $("#filters .tippcount").show();
        } else {
            $("#filters .tippcount").hide();
        }
        let sections = $("#filters .modules .module.active").find(".sections").html()
        $("#filters .current .sections").html(sections);
        $("#filters .current").collapse(sections ? "show" : "hide");

        setResultHeight();

        $("#result-wrapper").data("token", response.token);
        $("#job-radar").attr("href", "/abo?q=" + response.token).show();

        $("#result-list").removeClass("deferred");
        $("#result-wrapper").removeClass("old-search");

        $("#result-wrapper > .spinner").fadeOut();

    }).fail(function(response, textStatus, error) {
        if (error != "abort") {
            $("#result-wrapper > .spinner").fadeOut();
        }
    });
}

/**
 * Eine bestehende Suche Seitenweise nachladen
 */
function load() {
    //Bestehendes Laden priorisieren
    if ($("#result-list").hasClass("all-loaded") || loadXHR && loadXHR.readyState != 4 || searchXHR && searchXHR.readyState != 4) {
        return;
    }

    $("#result-more").addClass("disabled").attr("disabled", true);
    $("#result-list > .spinner").fadeIn();

    $("#navigator .more").addClass("disabled").attr("disabled", true);
    $("#navigator .more").find("i").addClass("fa-spin");

    //Daten aufbereiten
    let data = {
        token: $("#result-wrapper").data("token")
    };
    if ($("#result .fknd-job").length) {
        data.job_id = $("#result .fknd-job").data("id");
    }


    //AJAX
    loadXHR = $.ajax({
        "type": "POST",
        "url": "/suchergebnis",
        "dataType": "json",
        "headers": { "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content") },
        "data": data,
    }).done(function(response) {

        let wrapper = $(response.list);
        let list = $(wrapper).find("#result-list");
        $("#result-list").toggleClass("all-loaded", list.hasClass("all-loaded"));
        $("#result-wrapper").data("token", response.token);

        Object.keys(response.details).forEach(key => {
            jobs[key] = response.details[key];
        });

        if (response.ids) {
            let html = list.find('.list').html();
            $("#result-list").find('.list').last().append(html);
            window.checkSources("#result-list");
            window.deferredSrc("#result-list");
            tracking.send({cid: response.ids.join(","), type: 'list'});
            $("#navigator .next").prop('disabled',false).removeClass("disabled");
        }
        setResultHeight();

        $("#result-more").removeClass("disabled").attr("disabled", false);
        $("#result-list > .spinner").fadeOut();

        $("#navigator .more").removeClass("disabled").attr("disabled", false).addClass("d-none");
        $("#navigator .more").find("i").removeClass("fa-spin");
        $("#navigator .next").removeClass("d-none");
    }).fail(function(response, textStatus, error) {
        if (error != "abort") {
            $("#result-list > .spinner").fadeOut();
            $("#result-more").removeClass("disabled").attr("disabled", false);

            $("#navigator .more").removeClass("disabled").attr("disabled", false).addClass("d-none");
            $("#navigator .more").find("i").removeClass("fa-spin");
            $("#navigator .next").removeClass("d-none");
        }
    });
}

/**
 * Tippmodule erstellen und in den DOM rendern
 * @param {Array} modules Tippmodule
 */
function renderModules(modules) {
    let currentName = $("#filters .modules .module.active .head").text();
    $("#filters .modules .module").remove();
    for (let i = 0; i < modules.length; i++) {
        let html = `
            <div class="module ${ currentName == modules[i].headline || !currentName.length && modules[i].active == true ? 'active' : '' }">
                <div class="head">${ modules[i].headline }</div>
                <div class="sections">
        `;
        html += `<div class="section" data-type="${ modules[i].type }">`;
        if (modules[i].all) {
            html += `<div class="tipp all ${ modules[i].all_a ? 'active' : '' }" data-query="">${modules[i].all}</div>`;
        }
        for (let k = 0; k < modules[i].tipps.length; k++) {
            html += `<div class="tipp ${ modules[i].tipps[k].active ? 'active' : '' }" data-query="${modules[i].tipps[k].query}">${modules[i].tipps[k].title}</div>`;
        }
        html += `</div>`;
        if (modules[i].tipps2) {
            html += `
                <div class="section" data-type="${ modules[i].type2 }">
            `;
            if (modules[i].all2) {
                html += `<div class="tipp all ${ modules[i].all2_a ? 'active' : '' }" data-query="${ modules[i].all2_q ? modules[i].all2_q : '' }">${modules[i].all2}</div>`;
            }
            for (let k = 0; k < modules[i].tipps2.length; k++) {
                html += `<div class="tipp ${ modules[i].tipps2[k].active ? 'active' : '' }" data-query="${modules[i].tipps2[k].query}">${modules[i].tipps2[k].title}</div>`;
            }
            html += `</div>`;
        }
        html += `</div></div>`;
        $("#filters .modules").append(html);
    }
}

/**
 * Die Höhe der Anzeige anhand der des sichbaren Bereichs setzen
 */
function setResultHeight() {
    if ($(".fknd-job-nav #result-list").css("overflow-y") == 'auto') {
        let mh = 
            $(window).innerHeight() - 
            $(".fknd-job-nav #sidebar").position().top - 
            $(".fknd-job-nav #result-list").position().top + 
            Math.min(
                $(".fknd-job-nav #sidebar").position().top,
                $(window).scrollTop()
            );
        $(".fknd-job-nav #result-list").css("max-height", "calc(" + mh + "px - 2rem)");
    } else {
        $(".fknd-job-nav #result-list").css("max-height", "");
    }
}

function initToolbar() {
    $("#toolbar .apply").on("click", function(e) {
        tracking.send({cid: $(this).data('cid'), type: 'apply'});
        $("#modalApplication").modal("show");
    });

    $("#toolbar .original").on("click", function(e) {
        tracking.send({cid: $(this).data('cid'), type: 'website'});
        if ($(this).attr("href") == "#need-login") {
            e.preventDefault();
            $("#modalNeedLogin").modal("show");
        }
    });

    $("#toolbar .share")
        .collapse({toggle: false})
        .on("mouseout", function() {
            collapseShare();
        })
        .on("focusout", function() {
            setTimeout(function() {
                collapseShare()
            }, 100);
        });

    $("#toolbar .share-toggle")
        .on("blur", function() {
            setTimeout(function() {
                collapseShare()
            }, 100);
        })
        .on("click", function() {
            $("#toolbar .share").collapse("show");
        })
        .on("focus", function() {
            $("#toolbar .share").collapse("show");
        });
}


// WEBPACK FOOTER //
// ./resources/js/jobnav.js